const upload = {
    dragDrop: 'ファイルをドラッグ＆ドロップ',
    or: 'または',
    selectFiles: 'ファイルを選択',
    uploading: 'アップロード中...',
    processing: '処理中...',
    maxSize: '最大ファイルサイズ: {{size}}',
    allowedTypes: '対応ファイル形式: {{types}}',
    duplicateCheck: '重複チェック',
    uploadProgress: 'アップロード進捗',
    overallProgress: '全体進捗',
    currentFile: '現在のファイル',
    errors: 'エラー',
    // Upload Page specific
    pageTitle: 'ドキュメントをアップロード',
    selectDocuments: 'アップロードするドキュメントを選択',
    selectDocumentsDesc: 'ファイルをここにドラッグ＆ドロップするか、クリックして参照してください。',
    browseFiles: 'ファイルを参照',
    selectedFiles: '選択されたファイル',
    addMetadata: 'ドキュメントメタデータを追加',
    addMetadataDesc: 'ドキュメントに関する追加情報を提供して検索性を向上させます',
    uploadProgressTitle: 'アップロード進捗',
    uploadProgressDesc: 'ドキュメントがアップロードおよび処理されています',
    uploadComplete: 'アップロード完了！',
    uploadFinishedWithErrors: 'アップロードが完了しました（エラーあり）',
    uploadFailed: 'アップロードに失敗しました',
    uploadCompleteDesc: '{{total}}件中{{completed}}件のファイルが正常にアップロードされました。',
    backgroundProcessingTitle: 'アップロード済み・AI処理中',
    backgroundProcessingMessage: 'アップロード済み。AI処理はバックグラウンドで継続中です。',
    backgroundProcessingDesc: 'AI処理はバックグラウンドで継続中です。ドキュメント一覧または詳細から後で状態を確認できます。',
    viewDocuments: 'ドキュメントを表示',
    // Steps
    steps: {
      selectFiles: 'ファイルを選択',
      addMetadata: 'メタデータを追加',
      uploadProcess: 'アップロード＆処理',
    },
    // Duplicate dialog
    duplicateDetected: '重複ファイルが検出されました',
    duplicateWarning: '同じ内容のファイルがシステムに既に存在します。',
    duplicateFileName: 'ファイル名: {{name}}',
    duplicatePrompt: '同じファイル名のドキュメントが既に存在します。どのように処理しますか？',
    uploadingFile: 'アップロードしようとしているファイル:',
    existingFileInfo: '既存のファイル情報:',
    fileName: 'ファイル名',
    fileSize: 'ファイルサイズ',
    title: 'タイトル',
    currentVersion: '現在のバージョン',
    uploadedAt: 'アップロード日時',
    newVersionInfo: '「新しいバージョンとして保存」を選択すると、既存のファイルはそのまま残り、新しいファイルはVersion {{version}} として保存されます。',
    duplicateFile: 'ファイル',
    existingDocument: '既存のドキュメント',
    cancelUpload: 'アップロードをキャンセル',
    uploadAnyway: 'そのままアップロード',
    replaceExisting: '既存を置き換え',
    saveAsSeparate: '別のファイルとして保存',
    saveAsNewVersion: '新しいバージョンとして保存',
    // Navigation
    back: '戻る',
    stepProgress: 'ステップ {{current}}/{{total}}',
    next: '次へ',
    duplicate: '重複',
    // Confirmations
    confirmBack: {
      title: '前の手順に戻る',
      body: '入力したメタデータは保存されません。戻ると内容が破棄され、この操作は取り消せません。戻ってもよろしいですか？',
      confirm: '破棄して戻る',
    },
    confirmLeave: {
      title: 'アップロードを中断しますか',
      body: 'アップロード中のファイルがあります。この画面を離れると進捗が確認できなくなり、失敗したファイルの再試行もできません。離れてもよろしいですか？',
      confirm: '離れる',
    },
    // Dropzone
    dropFilesHere: 'ここにファイルをドロップ',
    dragDropFiles: 'ファイルをドラッグ＆ドロップ',
    orClickToBrowse: 'またはクリックしてファイルを参照',
    limitsTitle: 'アップロードできるファイルと上限',
    limitsLoading: '利用できる形式と上限を確認しています…',
    limitsUnavailable: '形式と上限を取得できませんでした。取得できるまでアップロードは行えません。',
    limitsFormats: '対応形式: {{types, list}}',
    limitsMaxSize: '1ファイルの上限: {{size}} MB',
    limitsMaxFiles: '同時に選択できる件数: {{count}} 件',
    csvScope: 'CSV: カンマ区切り、UTF-8・CP932・BOM付きUTF-16。本文取込は10 MiB、1万行・1,000列・10万セルまでです。',
    xlsmScope: 'XLSM: 保存済みセル値のみを取り込みます。マクロ実行・再計算・プレビューは対象外です。本文取込は10 MiB、100シート・各1万行・1,000列・計10万セルまでです。',
    maxFiles: '最大ファイル数: {{count}}',
    maxFilesError: '最大{{count}}個のファイルまでです',
    fileSizeError: '{{name}}: ファイルサイズが{{size}}MBの制限を超えています',
    fileTypeError: '{{name}}: サポートされていないファイル形式です。許可: {{types}}',
    progressTracker: {
      overallProgress: '全体進捗',
      fileProgress: 'ファイル進捗',
      completedCount: '{{count}}件完了',
      failedCount: '{{count}}件失敗',
      fileDetails: 'ファイル詳細',
      fileSize: 'ファイルサイズ:',
      fileType: 'ファイル種別:',
      progress: '進捗:',
      metadata: 'メタデータ',
      category: 'カテゴリー:',
      description: '説明:',
    },
    status: {
      pending: '待機中...',
      uploading: 'アップロード中... {{progress}}%',
      processing: '処理中...',
      completed: '完了',
      error: '失敗',
      duplicate: '重複ファイル',
      unknown: '不明',
    },
  };

export default upload;
